import { useState } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import Chart from './part/Chart';
import Alert from './part/Alert';
import TabLogs from './part/TabLogs';
import { request } from '../../interfaces/networkManager';
import { ProcessusLog } from '../../models/processusLog';
import Error from '../../components/Error/Error';
import { ConnectionStatistic } from './part/ConnectionStatistic';

export default function DashboardScreen() {
	const [logs, setLogs] = useState<ProcessusLog[] | null>(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const loadProcessLogs = () => {
		setIsLoading(true);
		setError(null);
		
		const requestOptions = {
			method: 'GET',
			headers: {
				Authorization: `JWT ${localStorage.getItem('token')}`,
			},
		};

		request<ProcessusLog[]>('/process-logs/?limit=100&offset=0', requestOptions)
			.then((logs: ProcessusLog[]) => {
				if (!logs.length) return setError('Erreur lors de la récupération des logs');
				setLogs(logs);
				setIsLoading(false);
			})
			.catch((error) => {
				setError(error instanceof globalThis.Error ? error.message : String(error));
				setIsLoading(false);
			});
	};

	return (
		<Container maxWidth="xl" sx={{ mt: 4, mb: 4, flexDirection: 'row' }}>
			<Grid container spacing={1}>
				<Grid size={12}>
					<Grid container spacing={3}>
						{/* Load Logs Button */}
						{!logs && (
							<Grid size={12}>
								<Paper sx={{ p: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
									<Button
										variant="contained"
										startIcon={isLoading ? <CircularProgress size={20} /> : <RefreshIcon />}
										onClick={loadProcessLogs}
										disabled={isLoading}
									>
										{isLoading ? 'Chargement des logs de processus...' : 'Charger les logs de processus'}
									</Button>
								</Paper>
							</Grid>
						)}
						
						{/* ConnectionStatistic - Always visible */}
						<Grid size={12}>
							<Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
								<ConnectionStatistic />
							</Paper>
						</Grid>
						
						{/* Chart and Alert - Only visible when logs are loaded */}
						{logs && (
							<>
								<Grid size={{xs:12, md:8, lg:9}}>
									<Paper
										sx={{
											p: 2,
											display: 'flex',
											flexDirection: 'column',
											height: 240,
										}}
									>
										<Chart logs={logs} />
									</Paper>
								</Grid>
								<Grid size={{xs:12, md:8, lg:9}}>
									<Paper
										sx={{
											p: 2,
											display: 'flex',
											flexDirection: 'column',
											height: 240,
										}}
									>
										<Alert logs={logs} />
									</Paper>
								</Grid>
								<Grid size={12}>
									<Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
										<TabLogs logs={logs} />
									</Paper>
								</Grid>
							</>
						)}
					</Grid>
				</Grid>
				{error ? (
					<Grid size={12}>
						<Error message={error} />
					</Grid>
				) : null}
			</Grid>
		</Container>
	);
}
